import { render, staticRenderFns } from "./Kindergartens.vue?vue&type=template&id=20afd79b&scoped=true"
import script from "./Kindergartens.vue?vue&type=script&lang=js"
export * from "./Kindergartens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20afd79b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\web\\medical\\medical-autism\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20afd79b')) {
      api.createRecord('20afd79b', component.options)
    } else {
      api.reload('20afd79b', component.options)
    }
    module.hot.accept("./Kindergartens.vue?vue&type=template&id=20afd79b&scoped=true", function () {
      api.rerender('20afd79b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/manage/kindergartens/Kindergartens.vue"
export default component.exports